import './AppStatusIndicator.scss';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DataSecurityAppActiveStatusType } from '@sonar-software/sonar-core';
import React from 'react';
import { SonarText } from '@ui/text';
const statusLabel = {
    [DataSecurityAppActiveStatusType.Operational]: COPY_SPECIFIC.OPERATIONAL,
    [DataSecurityAppActiveStatusType.Unknown]: COPY_SPECIFIC.UNKNOWN,
    [DataSecurityAppActiveStatusType.Major]: COPY_SPECIFIC.API_DOWNTIME,
    [DataSecurityAppActiveStatusType.Minor]: COPY_SPECIFIC.API_DOWNTIME,
    [DataSecurityAppActiveStatusType.Critical]: COPY_SPECIFIC.OUTAGE
};
export const AppStatusIndicator = ({ statusType }) => {
    const title = String(statusType);
    const innerClasses = classNames('status-indicator-inner', title === null || title === void 0 ? void 0 : title.toLowerCase());
    return (React.createElement("div", { className: 'app-status-indicator' },
        React.createElement("div", { className: 'status-indicator' },
            React.createElement("div", { className: innerClasses })),
        React.createElement(SonarText, { weight: 'semibold' }, statusLabel[statusType])));
};
